// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════
   Story 8.12 — Modale profil membre groupement (lecture seule)
   DA Centralis : bannières #595959, labels 1.1rem, valeurs 1.4rem
   ═══════════════════════════════════════════════════════════════════ */

/* ── Backdrop ──────────────────────────────────────────────────────── */

.modal-profil-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

/* ── Conteneur principal ───────────────────────────────────────────── */

.modal-profil-membre {
  width: 92vw;
  max-width: 1400px;
  height: 90vh;
  background: #fafafa;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

/* ── Bouton fermer ─────────────────────────────────────────────────── */

.modal-profil-close {
  position: absolute;
  top: 1.2rem;
  right: 1.5rem;
  z-index: 10;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  border: none;
  background: #f3f4f6;
  color: #374151;
  font-size: 1.6rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background 0.15s,
    color 0.15s;
}

.modal-profil-close:hover {
  background: #e5e7eb;
  color: #111827;
}

/* ── Badges header ─────────────────────────────────────────────────── */

.modal-profil-header-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.4rem 0 1rem;
}

.modal-profil-badge-type {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 1.1rem;
  font-weight: 700;
  background: #f97316;
  color: #fff;
  white-space: nowrap;
}

.modal-profil-badge-type--libre {
  background: #d1d5db;
  color: #374151;
}

.modal-profil-badge-type--suspendu {
  background: #9ca3af;
  color: #fff;
}

.modal-profil-badge-suspendu {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 1.1rem;
  font-weight: 700;
  background: #ef4444;
  color: #fff;
  white-space: nowrap;
}

.modal-profil-badge-contrat {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.7rem;
  border-radius: 6px;
  font-size: 1.1rem;
  font-weight: 600;
  background: #f3f4f6;
  color: #6b7280;
  border: 1px solid #e5e7eb;
  white-space: nowrap;
  cursor: pointer;
}

.modal-profil-badge-contrat:disabled {
  opacity: 0.6;
  cursor: default;
}

/* ── Loading & Error ───────────────────────────────────────────────── */

.modal-profil-loading,
.modal-profil-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  gap: 1rem;
}

.modal-profil-loading .spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e5e7eb;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.modal-profil-loading p {
  color: #6b7280;
  font-size: 1.3rem;
}

.modal-profil-error p {
  color: #ef4444;
  font-size: 1.3rem;
  text-align: center;
}

/* ── En-tête profil ────────────────────────────────────────────────── */

.modal-profil-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 3rem 2.5rem 1.5rem;
  background: #fff;
  /* border-bottom: 1px solid #e5e7eb; */
}

.modal-profil-header-left {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex: 1 1;
  min-width: 0;
}

.modal-profil-logo {
  width: 64px;
  height: 64px;
  border-radius: 10px;
  object-fit: contain;
  flex-shrink: 0;
}

.modal-profil-logo-placeholder {
  width: 64px;
  height: 64px;
  border-radius: 10px;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: 600;
  color: #9ca3af;
  flex-shrink: 0;
}

.modal-profil-identity {
  min-width: 0;
}

.modal-profil-identity h2 {
  font-size: 1.8rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.4rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-profil-details {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 1.5rem;
  font-size: 1.2rem;
  color: #6b7280;
}

.modal-profil-header-right {
  flex-shrink: 0;
  min-width: 160px;
}

/* ── Onglets ───────────────────────────────────────────────────────── */

.modal-profil-tabs {
  padding: 2rem 2.5rem;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}

/* Pastille sans numéro dans la modale (simple point rouge) */
.modal-profil-tabs .notification-badge {
  font-size: 0;
  width: 1rem;
  height: 1rem;
  padding: 0;
  min-width: unset;
}

/* ── Corps de la modale ────────────────────────────────────────────── */

.modal-profil-body {
  overflow-y: auto;
  padding: 2rem 2.5rem 2.5rem;
  flex: 1 1;
}

/* ═══════════════════════════════════════════════════════════════════
   Styles partagés ReadOnly — DA Centralis
   ═══════════════════════════════════════════════════════════════════ */

.readonly-tab {
  font-size: 1.3rem;
  color: #374151;
}

/* Section avec bannière #595959 */
.readonly-section {
  margin-bottom: 2rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.readonly-section:last-child {
  margin-bottom: 0;
}

/* Bannière de section — DA Centralis #595959 */
.readonly-section-title {
  background-color: #595959;
  color: #ffffff;
  padding: 1.25rem 1.5rem;
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0;
}

/* Contenu sous la bannière */
.readonly-section-content {
  padding: 1.5rem;
  background: #f9fafb;
}

/* ── Grilles ───────────────────────────────────────────────────────── */

.readonly-grid {
  display: grid;
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.readonly-grid:last-child {
  margin-bottom: 0;
}

.readonly-grid.three-cols {
  grid-template-columns: repeat(3, 1fr);
}

.readonly-grid.two-cols {
  grid-template-columns: repeat(2, 1fr);
}

/* ── Champ lecture seule ───────────────────────────────────────────── */

.readonly-field {
  margin-bottom: 0.8rem;
}

.readonly-field:last-child {
  margin-bottom: 0;
}

.readonly-field label {
  display: block;
  font-size: 1.3rem;
  font-weight: 700;
  color: #6b7280;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.readonly-field p {
  margin: 0;
  font-size: 1.4rem;
  color: #1f2937;
  word-break: break-word;
}

/* ── Texte long (description) ──────────────────────────────────────── */

.readonly-text-block {
  white-space: pre-wrap;
  line-height: 1.6;
  padding: 0.5rem 0 2rem;
  font-size: 1.4rem !important;
  color: #4b5563 !important;
}

/* ── Paires CA / RH ────────────────────────────────────────────────── */

.readonly-grid-pairs {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.readonly-pair {
  display: grid;
  grid-template-columns: 80px 1fr 80px 1fr;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1rem;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.pair-label {
  font-size: 1.1rem;
  font-weight: 500;
  color: #6b7280;
}

.pair-value {
  font-size: 1.4rem;
  color: #1f2937;
}

/* ── Hint ──────────────────────────────────────────────────────────── */

.readonly-hint {
  font-size: 1.2rem;
  color: #6b7280;
  margin: 0 0 1rem;
  font-style: italic;
}

/* ── Empty ─────────────────────────────────────────────────────────── */

.readonly-empty {
  color: #9ca3af;
  font-style: italic;
  font-size: 1.3rem;
  padding: 1.5rem 0;
}

/* ── Lots ──────────────────────────────────────────────────────────── */

.readonly-lots-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.readonly-lot-group {
  padding: 1rem 1.2rem;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.readonly-lot-name {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.5rem;
  font-size: 1.3rem;
}

.readonly-badge-ac {
  display: inline-block;
  font-size: 1rem;
  font-weight: 600;
  color: #f97316;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  vertical-align: middle;
}

.readonly-lot-depts {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.readonly-dept-tag {
  font-size: 1.1rem;
  color: #4b5563;
  background: #e5e7eb;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
}

/* ══════════════════════════════════════════════════════════════
   Documents — Chapitres thématiques (comme TabDocuments)
   ══════════════════════════════════════════════════════════════ */

.readonly-doc-chapter {
  margin-bottom: 2rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.readonly-doc-chapter:last-child {
  margin-bottom: 0;
}

.readonly-doc-chapter-header {
  background-color: #595959;
  color: #ffffff;
  padding: 1.25rem 1.5rem;
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0;
}

.readonly-doc-chapter-content {
  padding: 1.5rem;
}

.readonly-doc-section {
  margin-bottom: 1.5rem;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.readonly-doc-section:last-child {
  margin-bottom: 0;
}

.readonly-doc-section-header {
  /* background-color: #595959; */
  /* color: #ffffff; */
  /* padding: 0.75rem 1rem; */
  font-weight: 600;
  font-size: 1.4rem;
  margin: 0 0 1rem;
}

.readonly-doc-section-content {
  padding: 1rem;
  background: #fff;
}

.readonly-doc-section-content .documents-list {
  margin: 0 !important;
}

.readonly-doc-section-content .documents-grid {
  margin: 0 !important;
}

.readonly-doc-section-empty {
  font-size: 1.2rem;
  color: #9ca3af;
  font-style: italic;
  padding: 0.5rem 0;
}

/* ── Contact sections (Bancaire) ───────────────────────────────────── */

.readonly-contact-section {
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px dashed #e5e7eb;
}

.readonly-contact-section:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

/* ── Références ────────────────────────────────────────────────────── */

/* ── Références — style post réseau social ─────────────────────── */

.readonly-references-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.4rem;
}

.readonly-ref-post {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition:
    box-shadow 0.15s,
    transform 0.15s;
}

.readonly-ref-post:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

/* Cover photo */
.readonly-ref-post-cover {
  width: 100%;
  height: 160px;
  background-size: cover;
  background-position: center;
  cursor: zoom-in;
  flex-shrink: 0;
}

.readonly-ref-post-cover--placeholder {
  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);
  cursor: default;
}

/* Corps */
.readonly-ref-post-body {
  padding: 1.1rem 1.2rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  flex: 1 1;
}

/* Header : avatar + client + badge */
.readonly-ref-post-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.readonly-ref-post-avatar {
  width: 3.8rem;
  height: 3.8rem;
  border-radius: 50%;
  background: #fff;
  border: 1.5px solid #e5e7eb;
  color: #595959;
  font-size: 1.7rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.readonly-ref-post-avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 0.25rem;
}

.readonly-ref-post-meta {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}

.readonly-ref-post-entite {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.readonly-ref-post-client {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.readonly-ref-post-client-line {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  font-size: 1.1rem;
  margin-bottom: 0.2rem;
}

.readonly-ref-post-client-label {
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  font-size: 0.95rem;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.readonly-ref-post-client-value {
  color: #374151;
  font-weight: 500;
}

.readonly-ref-post-year {
  font-size: 1.05rem;
  color: #9ca3af;
}

/* Badge complet/incomplet */
.readonly-ref-badge {
  font-size: 1rem;
  font-weight: 600;
  padding: 0.25rem 0.7rem;
  border-radius: 6px;
  white-space: nowrap;
  flex-shrink: 0;
}

.readonly-ref-badge.complete {
  background: #dcfce7;
  color: #16a34a;
}

.readonly-ref-badge.incomplete {
  background: #fef3c7;
  color: #d97706;
}

/* Titre opération */
.readonly-ref-post-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}

/* Descriptif */
.readonly-ref-post-desc {
  font-size: 1.2rem;
  color: #4b5563;
  line-height: 1.55;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Footer budget */
.readonly-ref-post-footer {
  margin-top: auto;
  padding-top: 0.6rem;
  border-top: 1px solid #f3f4f6;
}

.readonly-ref-post-budget {
  font-size: 1.2rem;
  font-weight: 700;
  color: #f97316;
}

.readonly-photo-info {
  font-size: 1.2rem;
  color: #6b7280;
  font-style: italic;
}

/* ── Overlay Instagram ──────────────────────────────────────────── */

.readonly-ref-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.readonly-ref-overlay-close {
  position: absolute;
  top: 1.4rem;
  right: 1.4rem;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  font-size: 1.6rem;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.readonly-ref-overlay-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Boîte Instagram (image gauche + contenu droite) */
.readonly-ref-insta {
  display: flex;
  width: 1100px;
  height: 640px;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 12px 60px rgba(0, 0, 0, 0.4);
  flex-shrink: 0;
}

/* Côté image — taille fixe, bandeau noir automatique */
.readonly-ref-insta-img-wrap {
  flex: 0 0 58%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.readonly-ref-insta-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.readonly-ref-insta-img--placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
}

/* Côté contenu */
.readonly-ref-insta-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.6rem 1.8rem;
  overflow-y: auto;
}

.readonly-ref-insta-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-bottom: 1rem;
}

.readonly-ref-insta-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}

.readonly-ref-insta-client {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  font-size: 1.2rem;
  color: #374151;
}

.readonly-ref-insta-client-label {
  font-size: 1rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.readonly-ref-insta-desc {
  font-size: 1.25rem;
  color: #4b5563;
  line-height: 1.65;
  margin: 0;
  white-space: pre-wrap;
  flex: 1 1;
}

.readonly-ref-insta-footer {
  padding-top: 0.8rem;
  border-top: 1px solid #f3f4f6;
  margin-top: auto;
}

/* Wrapper flex : [‹] [modale] [›] */
.readonly-ref-insta-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Flèches de navigation — position fixe, centrées sur l'écran */
.readonly-ref-nav {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.18);
  border: none;
  color: #fff;
  font-size: 2.8rem;
  line-height: 1;
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 0.15rem 0;
  transition: background 0.15s;
  z-index: 10002;
}

.readonly-ref-nav:hover {
  background: rgba(255, 255, 255, 0.35);
}

.readonly-ref-nav--prev {
  left: 2rem;
}
.readonly-ref-nav--next {
  right: 2rem;
}

/* Avatar plus grand dans l'overlay */
.readonly-ref-insta-header .readonly-ref-post-avatar {
  width: 5rem;
  height: 5rem;
  font-size: 2.1rem;
}

/* Compteur X / N dans le header */
.readonly-ref-insta-counter {
  font-size: 1.05rem;
  color: #9ca3af;
}

/* Champs labelisés (Client / Année / Budget) */
.readonly-ref-insta-fields {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.5rem 1rem;
  padding: 0.8rem 0;
}

.readonly-ref-insta-field {
  display: contents;
}

.readonly-ref-insta-field-label {
  font-size: 1rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
  align-self: baseline;
  padding-top: 0.05rem;
}

.readonly-ref-insta-field-value {
  font-size: 1.2rem;
  color: #374151;
  font-weight: 500;
  align-self: baseline;
}

.readonly-photo-lightbox {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}

.readonly-photo-lightbox img {
  max-width: 90vw;
  max-height: 88vh;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
  object-fit: contain;
  cursor: default;
}

.readonly-photo-lightbox-close {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  font-size: 1.6rem;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.readonly-photo-lightbox-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ── Équipe ────────────────────────────────────────────────────────── */

.readonly-team-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.3rem;
}

.readonly-team-table th {
  text-align: left;
  padding: 0.8rem 1rem;
  background: #f3f4f6;
  color: #6b7280;
  font-weight: 600;
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  border-bottom: 2px solid #e5e7eb;
}

.readonly-team-table td {
  padding: 0.8rem 1rem;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
  font-size: 1.3rem;
}

.readonly-team-table tr:hover td {
  background: #f9fafb;
}

/* ── Affectation des membres (grille par lot géographique) ─────────── */

.readonly-affectations {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Section par lot technique */
.readonly-affectation-lot-section {
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
}

/* Bandeau lot technique pleine largeur */
.readonly-affectation-lot-banner {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 1.2rem;
  background: #595959;
  flex-wrap: wrap;
}

.readonly-affectation-lot-code {
  font-weight: 700;
  font-size: 1.25rem;
  color: #ffffff;
  white-space: nowrap;
}

.readonly-affectation-lot-sep {
  color: rgba(255, 255, 255, 0.45);
  font-size: 1.2rem;
}

.readonly-affectation-lot-nom {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.9);
  flex: 1 1;
  min-width: 0;
}

.readonly-affectation-contrat {
  font-size: 1.1rem;
  color: #fff;
  font-weight: 700;
  background: #f97316;
  padding: 0.2rem 0.8rem;
  border-radius: 20px;
  white-space: nowrap;
  margin-left: auto;
}

/* Liste de cartes pleine largeur */
.readonly-affectation-geo-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* Carte pleine largeur */
.readonly-affectation-geo-card {
  border: 1px solid #e5e7eb;
  border-top: none;
  overflow: hidden;
}

.readonly-affectation-geo-card:last-child {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

/* Pied de carte : zones couvertes */
.readonly-affectation-geo-footer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.6rem 0.9rem;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}

.readonly-affectation-geo-footer-label {
  font-size: 1.05rem;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding-top: 0.25rem;
  flex-shrink: 0;
}

.readonly-affectation-geo-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

/* Badge département :  [38] Isère  */
.readonly-affectation-geo-badge {
  display: inline-flex;
  align-items: center;
  gap: 0;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #d1d5db;
  font-size: 1.1rem;
  line-height: 1;
}

/* .readonly-affectation-geo-code {
  font-weight: 700;
  font-size: 1.05rem;
  color: #ffffff;
  background: #595959;
  padding: 0.2rem 0.45rem;
  letter-spacing: 0.02em;
  white-space: nowrap;
} */

.readonly-affectation-geo-sep {
  display: none;
}

.readonly-affectation-geo-nom {
  font-size: 1.1rem;
  color: #4b5563;
  font-weight: 400;
  background: #ffffff;
  padding: 0.2rem 0.55rem;
  white-space: nowrap;
}

/* Interlocuteurs dans la carte */
.readonly-affectation-interlocuteurs {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.7rem 0.9rem;
}

.readonly-affectation-interlocuteur {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.readonly-affectation-interlocuteur:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.readonly-affectation-name {
  font-weight: 600;
  font-size: 1.25rem;
  color: #374151;
}

.readonly-affectation-fonction {
  color: #6b7280;
  font-style: italic;
  font-size: 1.15rem;
}

.readonly-affectation-contact {
  color: #6b7280;
  font-size: 1.15rem;
}

.readonly-role-badge {
  font-size: 1.1rem;
  font-weight: 600;
  padding: 0.3rem 0.8rem;
  border-radius: 6px;
  display: inline-block;
}

.readonly-role-badge.admin {
  background: #f3f4f6;
  color: #374151;
}

.readonly-role-badge.gestionnaire {
  background: #f3f4f6;
  color: #374151;
}

.readonly-role-badge.signataire {
  background: #f3f4f6;
  color: #374151;
}

.readonly-role-badge.interlocuteur {
  background: #f3f4f6;
  color: #374151;
}

.readonly-role-badge.member {
  background: #f3f4f6;
  color: #374151;
}

/* ── IBAN masqué ───────────────────────────────────────────────────── */

.readonly-iban-masked {
  font-family: "Courier New", monospace;
  letter-spacing: 1px;
  color: #6b7280 !important;
}

/* ── Responsive ────────────────────────────────────────────────────── */

@media (max-width: 900px) {
  .modal-profil-membre {
    width: 96vw;
    height: 92vh;
  }

  .modal-profil-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 1.5rem 1.5rem 1rem;
  }

  .modal-profil-header-left {
    flex-direction: column;
    align-items: flex-start;
  }

  .modal-profil-body {
    padding: 1.5rem;
  }

  .readonly-grid.three-cols {
    grid-template-columns: 1fr 1fr;
  }

  .readonly-pair {
    grid-template-columns: 60px 1fr 60px 1fr;
  }
}

@media (max-width: 600px) {
  .readonly-grid.three-cols,
  .readonly-grid.two-cols {
    grid-template-columns: 1fr;
  }

  .readonly-pair {
    grid-template-columns: 1fr 1fr;
  }
}


.readonly-tab .document-chapter .chapter-content {
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/DetailCandidature/ModalProfilMembre.css"],"names":[],"mappings":"AAAA;;;wEAGwE;;AAExE,yEAAyE;;AAEzE;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,yEAAyE;;AAEzE;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yEAAyE;;AAEzE;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;eAEa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,yEAAyE;;AAEzE;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yEAAyE;;AAEzE;EACE,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA,yEAAyE;;AAEzE;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,SAAO;AACT;;AAEA;;wEAEwE;;AAExE;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,yEAAyE;;AAEzE;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,yEAAyE;;AAEzE;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yEAAyE;;AAEzE;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yEAAyE;;AAEzE;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;mEAEmE;;AAEnE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,yEAAyE;;AAEzE;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,yEAAyE;;AAEzE,qEAAqE;;AAErE;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,eAAe;EACf;;mBAEiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sEAAsE;;AAEtE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;AAC/D;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,yEAAyE;;AAEzE;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yEAAyE;;AAEzE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,MAAM;EACN,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yEAAyE;;AAEzE;EACE,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,yEAAyE;;AAEzE;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;AACF;;;AAGA;EACE,aAAa;AACf","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════\n   Story 8.12 — Modale profil membre groupement (lecture seule)\n   DA Centralis : bannières #595959, labels 1.1rem, valeurs 1.4rem\n   ═══════════════════════════════════════════════════════════════════ */\n\n/* ── Backdrop ──────────────────────────────────────────────────────── */\n\n.modal-profil-backdrop {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1100;\n}\n\n/* ── Conteneur principal ───────────────────────────────────────────── */\n\n.modal-profil-membre {\n  width: 92vw;\n  max-width: 1400px;\n  height: 90vh;\n  background: #fafafa;\n  border-radius: 12px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n\n/* ── Bouton fermer ─────────────────────────────────────────────────── */\n\n.modal-profil-close {\n  position: absolute;\n  top: 1.2rem;\n  right: 1.5rem;\n  z-index: 10;\n  width: 3.2rem;\n  height: 3.2rem;\n  border-radius: 50%;\n  border: none;\n  background: #f3f4f6;\n  color: #374151;\n  font-size: 1.6rem;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition:\n    background 0.15s,\n    color 0.15s;\n}\n\n.modal-profil-close:hover {\n  background: #e5e7eb;\n  color: #111827;\n}\n\n/* ── Badges header ─────────────────────────────────────────────────── */\n\n.modal-profil-header-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin: 0.4rem 0 1rem;\n}\n\n.modal-profil-badge-type {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  background: #f97316;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.modal-profil-badge-type--libre {\n  background: #d1d5db;\n  color: #374151;\n}\n\n.modal-profil-badge-type--suspendu {\n  background: #9ca3af;\n  color: #fff;\n}\n\n.modal-profil-badge-suspendu {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 1.1rem;\n  font-weight: 700;\n  background: #ef4444;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.modal-profil-badge-contrat {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.7rem;\n  border-radius: 6px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  background: #f3f4f6;\n  color: #6b7280;\n  border: 1px solid #e5e7eb;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.modal-profil-badge-contrat:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n/* ── Loading & Error ───────────────────────────────────────────────── */\n\n.modal-profil-loading,\n.modal-profil-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  gap: 1rem;\n}\n\n.modal-profil-loading .spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.modal-profil-loading p {\n  color: #6b7280;\n  font-size: 1.3rem;\n}\n\n.modal-profil-error p {\n  color: #ef4444;\n  font-size: 1.3rem;\n  text-align: center;\n}\n\n/* ── En-tête profil ────────────────────────────────────────────────── */\n\n.modal-profil-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  padding: 3rem 2.5rem 1.5rem;\n  background: #fff;\n  /* border-bottom: 1px solid #e5e7eb; */\n}\n\n.modal-profil-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.modal-profil-logo {\n  width: 64px;\n  height: 64px;\n  border-radius: 10px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.modal-profil-logo-placeholder {\n  width: 64px;\n  height: 64px;\n  border-radius: 10px;\n  background-color: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n\n.modal-profil-identity {\n  min-width: 0;\n}\n\n.modal-profil-identity h2 {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 0.4rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.modal-profil-details {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem 1.5rem;\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n\n.modal-profil-header-right {\n  flex-shrink: 0;\n  min-width: 160px;\n}\n\n/* ── Onglets ───────────────────────────────────────────────────────── */\n\n.modal-profil-tabs {\n  padding: 2rem 2.5rem;\n  border-bottom: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n/* Pastille sans numéro dans la modale (simple point rouge) */\n.modal-profil-tabs .notification-badge {\n  font-size: 0;\n  width: 1rem;\n  height: 1rem;\n  padding: 0;\n  min-width: unset;\n}\n\n/* ── Corps de la modale ────────────────────────────────────────────── */\n\n.modal-profil-body {\n  overflow-y: auto;\n  padding: 2rem 2.5rem 2.5rem;\n  flex: 1;\n}\n\n/* ═══════════════════════════════════════════════════════════════════\n   Styles partagés ReadOnly — DA Centralis\n   ═══════════════════════════════════════════════════════════════════ */\n\n.readonly-tab {\n  font-size: 1.3rem;\n  color: #374151;\n}\n\n/* Section avec bannière #595959 */\n.readonly-section {\n  margin-bottom: 2rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.readonly-section:last-child {\n  margin-bottom: 0;\n}\n\n/* Bannière de section — DA Centralis #595959 */\n.readonly-section-title {\n  background-color: #595959;\n  color: #ffffff;\n  padding: 1.25rem 1.5rem;\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* Contenu sous la bannière */\n.readonly-section-content {\n  padding: 1.5rem;\n  background: #f9fafb;\n}\n\n/* ── Grilles ───────────────────────────────────────────────────────── */\n\n.readonly-grid {\n  display: grid;\n  gap: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.readonly-grid:last-child {\n  margin-bottom: 0;\n}\n\n.readonly-grid.three-cols {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.readonly-grid.two-cols {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n/* ── Champ lecture seule ───────────────────────────────────────────── */\n\n.readonly-field {\n  margin-bottom: 0.8rem;\n}\n\n.readonly-field:last-child {\n  margin-bottom: 0;\n}\n\n.readonly-field label {\n  display: block;\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #6b7280;\n  margin-bottom: 0.25rem;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.readonly-field p {\n  margin: 0;\n  font-size: 1.4rem;\n  color: #1f2937;\n  word-break: break-word;\n}\n\n/* ── Texte long (description) ──────────────────────────────────────── */\n\n.readonly-text-block {\n  white-space: pre-wrap;\n  line-height: 1.6;\n  padding: 0.5rem 0 2rem;\n  font-size: 1.4rem !important;\n  color: #4b5563 !important;\n}\n\n/* ── Paires CA / RH ────────────────────────────────────────────────── */\n\n.readonly-grid-pairs {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.readonly-pair {\n  display: grid;\n  grid-template-columns: 80px 1fr 80px 1fr;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 0.8rem 1rem;\n  background: #fff;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n}\n\n.pair-label {\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.pair-value {\n  font-size: 1.4rem;\n  color: #1f2937;\n}\n\n/* ── Hint ──────────────────────────────────────────────────────────── */\n\n.readonly-hint {\n  font-size: 1.2rem;\n  color: #6b7280;\n  margin: 0 0 1rem;\n  font-style: italic;\n}\n\n/* ── Empty ─────────────────────────────────────────────────────────── */\n\n.readonly-empty {\n  color: #9ca3af;\n  font-style: italic;\n  font-size: 1.3rem;\n  padding: 1.5rem 0;\n}\n\n/* ── Lots ──────────────────────────────────────────────────────────── */\n\n.readonly-lots-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.readonly-lot-group {\n  padding: 1rem 1.2rem;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.readonly-lot-name {\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 0.5rem;\n  font-size: 1.3rem;\n}\n\n.readonly-badge-ac {\n  display: inline-block;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #f97316;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  padding: 0.15rem 0.5rem;\n  border-radius: 4px;\n  margin-left: 0.5rem;\n  vertical-align: middle;\n}\n\n.readonly-lot-depts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.readonly-dept-tag {\n  font-size: 1.1rem;\n  color: #4b5563;\n  background: #e5e7eb;\n  padding: 0.2rem 0.6rem;\n  border-radius: 4px;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   Documents — Chapitres thématiques (comme TabDocuments)\n   ══════════════════════════════════════════════════════════════ */\n\n.readonly-doc-chapter {\n  margin-bottom: 2rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.readonly-doc-chapter:last-child {\n  margin-bottom: 0;\n}\n\n.readonly-doc-chapter-header {\n  background-color: #595959;\n  color: #ffffff;\n  padding: 1.25rem 1.5rem;\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.readonly-doc-chapter-content {\n  padding: 1.5rem;\n}\n\n.readonly-doc-section {\n  margin-bottom: 1.5rem;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n}\n\n.readonly-doc-section:last-child {\n  margin-bottom: 0;\n}\n\n.readonly-doc-section-header {\n  /* background-color: #595959; */\n  /* color: #ffffff; */\n  /* padding: 0.75rem 1rem; */\n  font-weight: 600;\n  font-size: 1.4rem;\n  margin: 0 0 1rem;\n}\n\n.readonly-doc-section-content {\n  padding: 1rem;\n  background: #fff;\n}\n\n.readonly-doc-section-content .documents-list {\n  margin: 0 !important;\n}\n\n.readonly-doc-section-content .documents-grid {\n  margin: 0 !important;\n}\n\n.readonly-doc-section-empty {\n  font-size: 1.2rem;\n  color: #9ca3af;\n  font-style: italic;\n  padding: 0.5rem 0;\n}\n\n/* ── Contact sections (Bancaire) ───────────────────────────────────── */\n\n.readonly-contact-section {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px dashed #e5e7eb;\n}\n\n.readonly-contact-section:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n/* ── Références ────────────────────────────────────────────────────── */\n\n/* ── Références — style post réseau social ─────────────────────── */\n\n.readonly-references-list {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.4rem;\n}\n\n.readonly-ref-post {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n  cursor: pointer;\n  transition:\n    box-shadow 0.15s,\n    transform 0.15s;\n}\n\n.readonly-ref-post:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  transform: translateY(-2px);\n}\n\n/* Cover photo */\n.readonly-ref-post-cover {\n  width: 100%;\n  height: 160px;\n  background-size: cover;\n  background-position: center;\n  cursor: zoom-in;\n  flex-shrink: 0;\n}\n\n.readonly-ref-post-cover--placeholder {\n  background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%);\n  cursor: default;\n}\n\n/* Corps */\n.readonly-ref-post-body {\n  padding: 1.1rem 1.2rem 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  flex: 1;\n}\n\n/* Header : avatar + client + badge */\n.readonly-ref-post-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.readonly-ref-post-avatar {\n  width: 3.8rem;\n  height: 3.8rem;\n  border-radius: 50%;\n  background: #fff;\n  border: 1.5px solid #e5e7eb;\n  color: #595959;\n  font-size: 1.7rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.readonly-ref-post-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  padding: 0.25rem;\n}\n\n.readonly-ref-post-meta {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.readonly-ref-post-entite {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1f2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.readonly-ref-post-client {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1f2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.readonly-ref-post-client-line {\n  display: flex;\n  align-items: baseline;\n  gap: 0.4rem;\n  font-size: 1.1rem;\n  margin-bottom: 0.2rem;\n}\n\n.readonly-ref-post-client-label {\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  font-size: 0.95rem;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n.readonly-ref-post-client-value {\n  color: #374151;\n  font-weight: 500;\n}\n\n.readonly-ref-post-year {\n  font-size: 1.05rem;\n  color: #9ca3af;\n}\n\n/* Badge complet/incomplet */\n.readonly-ref-badge {\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 0.25rem 0.7rem;\n  border-radius: 6px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.readonly-ref-badge.complete {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.readonly-ref-badge.incomplete {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n/* Titre opération */\n.readonly-ref-post-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.3;\n}\n\n/* Descriptif */\n.readonly-ref-post-desc {\n  font-size: 1.2rem;\n  color: #4b5563;\n  line-height: 1.55;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Footer budget */\n.readonly-ref-post-footer {\n  margin-top: auto;\n  padding-top: 0.6rem;\n  border-top: 1px solid #f3f4f6;\n}\n\n.readonly-ref-post-budget {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #f97316;\n}\n\n.readonly-photo-info {\n  font-size: 1.2rem;\n  color: #6b7280;\n  font-style: italic;\n}\n\n/* ── Overlay Instagram ──────────────────────────────────────────── */\n\n.readonly-ref-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: rgba(0, 0, 0, 0.78);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.readonly-ref-overlay-close {\n  position: absolute;\n  top: 1.4rem;\n  right: 1.4rem;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: #fff;\n  font-size: 1.6rem;\n  width: 3.2rem;\n  height: 3.2rem;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n}\n\n.readonly-ref-overlay-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* Boîte Instagram (image gauche + contenu droite) */\n.readonly-ref-insta {\n  display: flex;\n  width: 1100px;\n  height: 640px;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 12px 60px rgba(0, 0, 0, 0.4);\n  flex-shrink: 0;\n}\n\n/* Côté image — taille fixe, bandeau noir automatique */\n.readonly-ref-insta-img-wrap {\n  flex: 0 0 58%;\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.readonly-ref-insta-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.readonly-ref-insta-img--placeholder {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #1f2937 0%, #374151 100%);\n}\n\n/* Côté contenu */\n.readonly-ref-insta-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1.6rem 1.8rem;\n  overflow-y: auto;\n}\n\n.readonly-ref-insta-header {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding-bottom: 1rem;\n}\n\n.readonly-ref-insta-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.3;\n}\n\n.readonly-ref-insta-client {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n  font-size: 1.2rem;\n  color: #374151;\n}\n\n.readonly-ref-insta-client-label {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.readonly-ref-insta-desc {\n  font-size: 1.25rem;\n  color: #4b5563;\n  line-height: 1.65;\n  margin: 0;\n  white-space: pre-wrap;\n  flex: 1;\n}\n\n.readonly-ref-insta-footer {\n  padding-top: 0.8rem;\n  border-top: 1px solid #f3f4f6;\n  margin-top: auto;\n}\n\n/* Wrapper flex : [‹] [modale] [›] */\n.readonly-ref-insta-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Flèches de navigation — position fixe, centrées sur l'écran */\n.readonly-ref-nav {\n  position: fixed;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.18);\n  border: none;\n  color: #fff;\n  font-size: 2.8rem;\n  line-height: 1;\n  width: 3.6rem;\n  height: 3.6rem;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0 0.15rem 0;\n  transition: background 0.15s;\n  z-index: 10002;\n}\n\n.readonly-ref-nav:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n.readonly-ref-nav--prev {\n  left: 2rem;\n}\n.readonly-ref-nav--next {\n  right: 2rem;\n}\n\n/* Avatar plus grand dans l'overlay */\n.readonly-ref-insta-header .readonly-ref-post-avatar {\n  width: 5rem;\n  height: 5rem;\n  font-size: 2.1rem;\n}\n\n/* Compteur X / N dans le header */\n.readonly-ref-insta-counter {\n  font-size: 1.05rem;\n  color: #9ca3af;\n}\n\n/* Champs labelisés (Client / Année / Budget) */\n.readonly-ref-insta-fields {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.5rem 1rem;\n  padding: 0.8rem 0;\n}\n\n.readonly-ref-insta-field {\n  display: contents;\n}\n\n.readonly-ref-insta-field-label {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  white-space: nowrap;\n  align-self: baseline;\n  padding-top: 0.05rem;\n}\n\n.readonly-ref-insta-field-value {\n  font-size: 1.2rem;\n  color: #374151;\n  font-weight: 500;\n  align-self: baseline;\n}\n\n.readonly-photo-lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: rgba(0, 0, 0, 0.82);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: zoom-out;\n}\n\n.readonly-photo-lightbox img {\n  max-width: 90vw;\n  max-height: 88vh;\n  border-radius: 10px;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);\n  object-fit: contain;\n  cursor: default;\n}\n\n.readonly-photo-lightbox-close {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: #fff;\n  font-size: 1.6rem;\n  width: 3.2rem;\n  height: 3.2rem;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n}\n\n.readonly-photo-lightbox-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* ── Équipe ────────────────────────────────────────────────────────── */\n\n.readonly-team-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 1.3rem;\n}\n\n.readonly-team-table th {\n  text-align: left;\n  padding: 0.8rem 1rem;\n  background: #f3f4f6;\n  color: #6b7280;\n  font-weight: 600;\n  font-size: 1.1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n  border-bottom: 2px solid #e5e7eb;\n}\n\n.readonly-team-table td {\n  padding: 0.8rem 1rem;\n  border-bottom: 1px solid #f3f4f6;\n  color: #374151;\n  font-size: 1.3rem;\n}\n\n.readonly-team-table tr:hover td {\n  background: #f9fafb;\n}\n\n/* ── Affectation des membres (grille par lot géographique) ─────────── */\n\n.readonly-affectations {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n/* Section par lot technique */\n.readonly-affectation-lot-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n/* Bandeau lot technique pleine largeur */\n.readonly-affectation-lot-banner {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.7rem 1.2rem;\n  background: #595959;\n  flex-wrap: wrap;\n}\n\n.readonly-affectation-lot-code {\n  font-weight: 700;\n  font-size: 1.25rem;\n  color: #ffffff;\n  white-space: nowrap;\n}\n\n.readonly-affectation-lot-sep {\n  color: rgba(255, 255, 255, 0.45);\n  font-size: 1.2rem;\n}\n\n.readonly-affectation-lot-nom {\n  font-size: 1.2rem;\n  color: rgba(255, 255, 255, 0.9);\n  flex: 1;\n  min-width: 0;\n}\n\n.readonly-affectation-contrat {\n  font-size: 1.1rem;\n  color: #fff;\n  font-weight: 700;\n  background: #f97316;\n  padding: 0.2rem 0.8rem;\n  border-radius: 20px;\n  white-space: nowrap;\n  margin-left: auto;\n}\n\n/* Liste de cartes pleine largeur */\n.readonly-affectation-geo-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* Carte pleine largeur */\n.readonly-affectation-geo-card {\n  border: 1px solid #e5e7eb;\n  border-top: none;\n  overflow: hidden;\n}\n\n.readonly-affectation-geo-card:last-child {\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n/* Pied de carte : zones couvertes */\n.readonly-affectation-geo-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.65rem;\n  padding: 0.6rem 0.9rem;\n  background: #f9fafb;\n  border-top: 1px solid #e5e7eb;\n}\n\n.readonly-affectation-geo-footer-label {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding-top: 0.25rem;\n  flex-shrink: 0;\n}\n\n.readonly-affectation-geo-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n/* Badge département :  [38] Isère  */\n.readonly-affectation-geo-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0;\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid #d1d5db;\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n/* .readonly-affectation-geo-code {\n  font-weight: 700;\n  font-size: 1.05rem;\n  color: #ffffff;\n  background: #595959;\n  padding: 0.2rem 0.45rem;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n} */\n\n.readonly-affectation-geo-sep {\n  display: none;\n}\n\n.readonly-affectation-geo-nom {\n  font-size: 1.1rem;\n  color: #4b5563;\n  font-weight: 400;\n  background: #ffffff;\n  padding: 0.2rem 0.55rem;\n  white-space: nowrap;\n}\n\n/* Interlocuteurs dans la carte */\n.readonly-affectation-interlocuteurs {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0.7rem 0.9rem;\n}\n\n.readonly-affectation-interlocuteur {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.readonly-affectation-interlocuteur:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.readonly-affectation-name {\n  font-weight: 600;\n  font-size: 1.25rem;\n  color: #374151;\n}\n\n.readonly-affectation-fonction {\n  color: #6b7280;\n  font-style: italic;\n  font-size: 1.15rem;\n}\n\n.readonly-affectation-contact {\n  color: #6b7280;\n  font-size: 1.15rem;\n}\n\n.readonly-role-badge {\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding: 0.3rem 0.8rem;\n  border-radius: 6px;\n  display: inline-block;\n}\n\n.readonly-role-badge.admin {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.readonly-role-badge.gestionnaire {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.readonly-role-badge.signataire {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.readonly-role-badge.interlocuteur {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.readonly-role-badge.member {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n/* ── IBAN masqué ───────────────────────────────────────────────────── */\n\n.readonly-iban-masked {\n  font-family: \"Courier New\", monospace;\n  letter-spacing: 1px;\n  color: #6b7280 !important;\n}\n\n/* ── Responsive ────────────────────────────────────────────────────── */\n\n@media (max-width: 900px) {\n  .modal-profil-membre {\n    width: 96vw;\n    height: 92vh;\n  }\n\n  .modal-profil-header {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 1.5rem 1.5rem 1rem;\n  }\n\n  .modal-profil-header-left {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .modal-profil-body {\n    padding: 1.5rem;\n  }\n\n  .readonly-grid.three-cols {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .readonly-pair {\n    grid-template-columns: 60px 1fr 60px 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .readonly-grid.three-cols,\n  .readonly-grid.two-cols {\n    grid-template-columns: 1fr;\n  }\n\n  .readonly-pair {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n\n.readonly-tab .document-chapter .chapter-content {\n  padding: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
